import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../style/contactPage/contactpage.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";

function ContactDownloads() {
  return (
    <div>
      <Row className="text-box-div download-div d-flex justify-content-between"></Row>
    </div>
  );
}

export default ContactDownloads;
